module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30.462 2.488l-2.718 2.72a7.634 7.634 0 0 0-.452-.502C24.308 1.734 20.266 0 16 0 7.178 0 0 7.178 0 16s7.178 16 16 16c7.14 0 13.302-4.594 15.336-11.43a2 2 0 0 0-3.832-1.14C25.976 24.554 21.356 28 16 28 9.382 28 4 22.618 4 16S9.382 4 16 4c3.2 0 6.23 1.3 8.472 3.53l.408.542-4.39 4.39c-.85.85-.566 1.538.636 1.538h9.786c.602 0 1.088-.486 1.088-1.088V3.126c0-1.202-.688-1.486-1.538-.638z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/refresh-1.js
// module id = 1364
// module chunks = 14